export default "__VITE_ASSET__CumHV05c__"